
import classtypes from '../api/class-types'

export const state = {
  class_types: [],
  class_type_pagination_data: {},
  class_type: ''
}

export const getters = {
  class_types: state => state.class_types,
  class_type_pagination_data: state => state.class_type_pagination_data,
  class_type: state => state.class_type
}

export const mutations = {
  ADD_CLASS_TYPE (state, data) {
    state.class_types.push(data)
  },
  SET_CLASS_TYPES (state, data) {
    state.class_types = data
  },
  SET_CLASS_TYPE_PAGINATION (state, data) {
    state.class_type_pagination_data = data
  },
  SHOW_CLASS_TYPE (state, data) {
    state.class_type = data
  }
}

export const actions = {
  GET_CLASS_TYPES ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      classtypes.get(data).then(response => {
        if (response.data.data) {
          commit('SET_CLASS_TYPES', response.data.data)
          let paginationData = {
            from: response.data.from,
            to: response.data.to,
            total: response.data.total,
            last_page: response.data.last_page
          }
          commit('SET_CLASS_TYPE_PAGINATION', paginationData)
        } else {
          commit('SET_CLASS_TYPES', response.data)
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  CREATE_CLASS_TYPE ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      classtypes.create(data).then(response => {
        commit('ADD_CLASS_TYPE', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  SHOW_CLASS_TYPE ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      classtypes.show(id).then(response => {
        commit('SHOW_CLASS_TYPE', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  EDIT_CLASS_TYPE ({ commit, getters }, payload) {
    return new Promise((resolve, reject) => {
      classtypes.update(payload.data, payload.id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  REMOVE_CLASS_TYPE ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      classtypes.delete(id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  BULK_REMOVE_CLASS_TYPES ({ commit, getters }, ids) {
    return new Promise((resolve, reject) => {
      classtypes.bulkDelete(ids).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/class-types.js